import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Cookies from "js-cookie";
import { Provider } from '@shopify/app-bridge-react';
import { AppProvider } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/en.json';

import App from './App';
import AppFrame from './componets/AppFrame';

const AppRoot = () => {
    const config = { apiKey: '88720afe042176f7f3f47ebb7d10a499', shopOrigin: Cookies.get("shop"), forceRedirect: true }
    return (
        <BrowserRouter>
            <Provider config={config}>
                <AppProvider i18n={translations}>
                    <AppFrame>
                        <App />
                    </AppFrame>
                </AppProvider>
            </Provider>
        </BrowserRouter>
    )
}

ReactDOM.render(<AppRoot />, document.getElementById('root'));